const data = [
    {id:1, link:'#', title: 'Home'},
    {id:2, link: '#about', title: 'About'},
    {id:3, link: '#portfolio', title: 'Projects'},
    {id:4, link: '#contact', title: 'Contact'}
]

export default data;